import { ItemException } from "../models/item.exception";

export const formatItemConditions = (exceptions: ItemException[], isDelivery: boolean): string => {
  let conditions = "";

  const exceptionsFiltered = exceptions?.filter(
    (exception) => (exception?.isDelivery || false) === (isDelivery || false)
  );

  if (exceptionsFiltered) {
    let currentPrefix;

    for (const exception of exceptionsFiltered) {
      if (exception.exceptionSymbol && exception.locationSymbol) {
        if (currentPrefix !== exception.exceptionSymbol.prefix)
          conditions += `- ${exception.exceptionSymbol.prefix} `;

        conditions += `${exception.locationSymbol.prefix} `;
        currentPrefix = exception.exceptionSymbol.prefix;
      }
    }

    if (conditions !== "") conditions = conditions.substring(2);
    if (conditions.length > 2) conditions = conditions.substring(0, conditions.length - 1);
  }

  return conditions;
};
